import { AccessPermissionsResponse } from './permissionsDataTransformer'
import { generateSrn, RequiredPermissionParams } from './srnGenerator'
import { getPermission, PermissionAction } from './srnParser'

const NOT_EXISTING_PERMISSION_NUMBER = -1

export const hasSystemPermission = ({
  module,
  requiredPermission,
  clinicId,
  getSystemPermissionsForModule,
}: {
  module: string
  requiredPermission: string
  clinicId: number
  getSystemPermissionsForModule: (
    clinicId: number,
    module: string,
  ) => string[] | undefined
}) => {
  const moduleSystemPermissionsList = getSystemPermissionsForModule(
    clinicId,
    module,
  )

  return moduleSystemPermissionsList?.includes(requiredPermission) ?? false
}

export const hasContentPermission = ({
  clinicId,
  askedPermission,
  requiredPermission,
  data,
  getPermissionsForModule,
}: {
  clinicId: number
  askedPermission: RequiredPermissionParams
  requiredPermission: string
  data: AccessPermissionsResponse | undefined
  getPermissionsForModule: (
    clinicId: number,
    module: string,
  ) => Map<string, number[]> | undefined
}) => {
  const permissionsForSrn = getPermissionsForModule(
    clinicId,
    askedPermission.module,
  )?.get(generateSrn(clinicId, askedPermission))

  const checkingViewPermission =
    askedPermission.action === PermissionAction.VIEW

  const viewAllPermission = getPermission({
    ...askedPermission,
    action: 'view_all',
  })

  const permissionNumber = data
    ? data.permissions?.[requiredPermission]
    : NOT_EXISTING_PERMISSION_NUMBER

  const viewAllPermissionNumber =
    data && checkingViewPermission
      ? data.permissions?.[viewAllPermission]
      : NOT_EXISTING_PERMISSION_NUMBER

  return (
    permissionsForSrn?.includes(permissionNumber) ||
    (checkingViewPermission &&
      permissionsForSrn?.includes(Number(viewAllPermissionNumber)))
  )
}

export const hasAnyResourceInModuleWithViewPermission = ({
  data,
  module,
  requiredPermission,
  clinicId,
  getPermissionsForModule,
}: {
  data: AccessPermissionsResponse | undefined
  module: string
  requiredPermission: string
  clinicId: number
  getPermissionsForModule: (
    clinicId: number,
    module: string,
  ) => Map<string, number[]> | undefined
}) => {
  const permissionNumber = data
    ? data.permissions?.[requiredPermission]
    : NOT_EXISTING_PERMISSION_NUMBER

  return Array.from(
    getPermissionsForModule(clinicId, module)?.values() ?? [],
  ).some((assignedPermissionsPerResourceItem) =>
    assignedPermissionsPerResourceItem.includes(permissionNumber),
  )
}
